/**
 * @module question_logic.transformer
 */

/**
 * Transform logics from the server form to the front-end form.
 *
 * @example logics (from server)
 * {
 *   "id": 3,
 *   "surveyId": 5,
 *   "mainSurveyElementId": 123,
 *   "affectedSurveyElementId": 124,
 *   "rating": 1,  // If mainSurveyElement is rating question
 *   "isHigherThan": false,  // If mainSurveyElement is rating question
 *   "isLowerThan": false,  // If mainSurveyElement is rating question
 *   "isEqualsTo": true  // If mainSurveyElement is rating question
 *   "surveyElementQuestionOptionsChoiceId": 233 // If mainSurveyElement is options question
 * }
 */
const questionlogicFrom = (questionLogic) => {
  return {
    id: questionLogic.id,
    surveyId: questionLogic.surveyId,
    mainSurveyElementId: questionLogic.mainSurveyElementId,
    affectedSurveyElementId: questionLogic.affectedSurveyElementId,
    rating: questionLogic.rating,
    isHigherThan: !!questionLogic.isHigherThan,
    isLowerThan: !!questionLogic.isLowerThan,
    isEqualsTo: !!questionLogic.isEqualsTo,
    surveyElementQuestionOptionsChoiceId: questionLogic.surveyElementQuestionOptionsChoiceId,
  };
};

const questionLogicsFrom = (questionLogics) => {
  const logics = questionLogics ? questionLogics.map((questionLogic) => questionlogicFrom(questionLogic)) : [];

  return logics;
};

export { questionlogicFrom, questionLogicsFrom };
